import axios from "@/api/axiosInstance";
import { GetBillingSubscriptionsResponse } from "./types";

export const getBillingSubscriptions = async (
  signal?: AbortSignal,
): Promise<GetBillingSubscriptionsResponse> => {
  const response = await axios.get<GetBillingSubscriptionsResponse>(
    "/api/private/billing/subscriptions",
    { signal },
  );
  return response.data;
};
